<template>
  <div class="city-confirmation">
    <page-info
      class="city-confirmation__info"
      title="Уверены, что хотите изменить регион доставки?"
      subtitle="Обращаем ваше внимание, что стоимость и наличие товаров могут измениться"
    />

    <div class="city-confirmation__buttons">
      <ui-button
        secondary
        class="city-confirmation__button"
        text="Отменить"
        @click="$emit('choose', false)"
      />
      <ui-button
        class="city-confirmation__buttons yes"
        text="Изменить"
        @click="choose"
      />
    </div>

    <transition name="fade">
      <ui-loader
        v-if="isLoading"
        class="city-confirmation__loader"
        size="60"
      />
    </transition>
  </div>
</template>

<script>
import PageInfo from '../common/page-info';

export default {
  name: 'city-confirmation',

  components: {
    PageInfo
  },

  data() {
    return {
      isLoading: false
    }
  },

  methods: {
    choose() {
      this.isLoading = true;
      this.$emit('choose', true);
    }
  }
};
</script>

<style lang="scss">
.city-confirmation {
  &__info {
    margin: 16px 0 0;

    .description {
      padding: 4px 8px 16px;
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column-reverse;

    .city-confirmation__button {
      width: 100%;
      margin-top: 8px;
    }
  }

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    color: $blue;
    transform: translate(-50%, -50%);
  }
}

@include breakpoint("desktop") {
  .city-confirmation {
    &__info {
      margin: 0;

      .description {
        padding: 8px;
      }
    }

    &__buttons {
      justify-content: center;
      flex-direction: row;

      .city-confirmation__button {
        width: 96px;
      }

      &.yes {
        margin: 8px 0 0 11px;
      }
    }
  }
}
</style>